import { render, staticRenderFns } from "./add-employee.vue?vue&type=template&id=33a12ac1"
import script from "./add-employee.vue?vue&type=script&lang=js"
export * from "./add-employee.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports